export default "__VITE_ASSET__DQQHuIpJ__"